/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GuidFilterItemOutput,
    GuidFilterItemOutputFromJSON,
    GuidFilterItemOutputFromJSONTyped,
    GuidFilterItemOutputToJSON,
} from './';

/**
 * 
 * @export
 * @interface GuidGuidFilterItemOutputIEnumerableKeyValuePair
 */
export interface GuidGuidFilterItemOutputIEnumerableKeyValuePair {
    /**
     * 
     * @type {string}
     * @memberof GuidGuidFilterItemOutputIEnumerableKeyValuePair
     */
    key?: string;
    /**
     * 
     * @type {Array<GuidFilterItemOutput>}
     * @memberof GuidGuidFilterItemOutputIEnumerableKeyValuePair
     */
    value?: Array<GuidFilterItemOutput> | null;
}

export function GuidGuidFilterItemOutputIEnumerableKeyValuePairFromJSON(json: any): GuidGuidFilterItemOutputIEnumerableKeyValuePair {
    return GuidGuidFilterItemOutputIEnumerableKeyValuePairFromJSONTyped(json, false);
}

export function GuidGuidFilterItemOutputIEnumerableKeyValuePairFromJSONTyped(json: any, ignoreDiscriminator: boolean): GuidGuidFilterItemOutputIEnumerableKeyValuePair {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key': !exists(json, 'key') ? undefined : json['key'],
        'value': !exists(json, 'value') ? undefined : (json['value'] === null ? null : (json['value'] as Array<any>).map(GuidFilterItemOutputFromJSON)),
    };
}

export function GuidGuidFilterItemOutputIEnumerableKeyValuePairToJSON(value?: GuidGuidFilterItemOutputIEnumerableKeyValuePair | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'key': value.key,
        'value': value.value === undefined ? undefined : (value.value === null ? null : (value.value as Array<any>).map(GuidFilterItemOutputToJSON)),
    };
}


